import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { AddProduct, ECommerce, ProductForm } from "../../../../Constants/Constants";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ProductLeftSidebar from "./ProductBody/ProductLeftSidebar";
import ProductTabContent from "./ProductBody/ProductTabContent";

const AddProductContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={AddProduct} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card>
              <CommonCardHeader title={ProductForm} />
              <CardBody>
                <Row className="g-xl-5 g-3">
                  <ProductLeftSidebar />
                  <ProductTabContent />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddProductContainer;
